import { computed, hasInjectionContext, inject, type InjectionKey } from "vue";
import type { HapticsContext } from "./types";

const defaultHapticsContext: HapticsContext = {
  isEnabled: computed(() => false),
};

export const HAPTICS_KEY: InjectionKey<HapticsContext> = Symbol("haptics");

export const useHapticsContext = (): HapticsContext => {
  if (!hasInjectionContext()) {
    return defaultHapticsContext;
  }

  const context = inject(HAPTICS_KEY, undefined);

  if (!context) {
    return defaultHapticsContext;
  }

  return context;
};
